import { Diagnostic } from "@siteimprove/alfa-act";
/**
 * @public
 */
export class TextSpacing extends Diagnostic {
    static of(message, property, value, fontSize, ratio, threshold, declaration, owner) {
        return property === undefined
            ? Diagnostic.of(message)
            : new TextSpacing(message, property, value, fontSize, ratio, threshold, declaration, owner);
    }
    _property;
    _value;
    _fontSize;
    _ratio;
    _threshold;
    // The bad declaration in the style attribute
    _declaration;
    // The element with the bad style attribute
    _owner;
    constructor(message, property, value, fontSize, ratio, threshold, declaration, owner) {
        super(message);
        this._property = property;
        this._value = value;
        this._fontSize = fontSize;
        this._ratio = ratio;
        this._threshold = threshold;
        this._declaration = declaration;
        this._owner = owner;
    }
    get property() {
        return this._property;
    }
    get value() {
        return this._value;
    }
    get fontSize() {
        return this._fontSize;
    }
    get ratio() {
        return this._ratio;
    }
    get threshold() {
        return this._threshold;
    }
    get declaration() {
        return this._declaration;
    }
    get owner() {
        return this._owner;
    }
    equals(value) {
        return (value instanceof TextSpacing &&
            value._message === this._message &&
            value._property === this._property &&
            value._value.equals(this._value) &&
            value._fontSize.equals(this._fontSize) &&
            value._ratio === this._ratio &&
            value._declaration.equals(this._declaration) &&
            value._owner.equals(this._owner));
    }
    hash(hash) {
        super.hash(hash);
        this._owner.hash(hash);
        hash.writeString(this._property);
        hash.writeNumber(this._ratio);
        hash.writeNumber(this._threshold);
        hash.writeNumber(this._value.value);
    }
    toJSON(options) {
        return {
            ...super.toJSON(options),
            property: this._property,
            value: this._value.toJSON(),
            "font-size": this._fontSize.toJSON(),
            ratio: this._ratio,
            threshold: this._threshold,
            declaration: this._declaration.toJSON(),
            owner: this._owner.toJSON(options),
        };
    }
}
/**
 * @public
 */
(function (TextSpacing) {
    function isTextSpacing(value) {
        return value instanceof TextSpacing;
    }
    TextSpacing.isTextSpacing = isTextSpacing;
})(TextSpacing || (TextSpacing = {}));
//# sourceMappingURL=text-spacing.js.map